'use client'

import { LocaleIdentifier } from '@repo/markets/types'
import { motion, useScroll, useTransform } from 'motion/react'
import { PortableTextBlock } from 'next-sanity'
import { FunctionComponent } from 'react'
import PortableText from '../../text/PortableText'

interface Props {
  title: string
  locale: LocaleIdentifier
  description?: PortableTextBlock[]
}

const CollectionHeader: FunctionComponent<Props> = ({ title, locale, description }) => {
  const { scrollY } = useScroll()
  const titleY = useTransform(scrollY, [0, 300], [0, -20])
  const descriptionY = useTransform(scrollY, [0, 300], [0, 30])

  return (
    <motion.header className='px-miista-page-padding group relative min-h-[6rem] w-full overflow-hidden md:min-h-[8rem]'>
      <motion.div className='absolute inset-0 flex items-center justify-center !truncate bg-white text-center' style={{ y: titleY }}>
        <h1 className='text-[clamp(3rem,_calc(2.25rem_+_3svw),_4.5rem)] font-light uppercase italic tracking-[-0.05em] transition-opacity duration-200 ease-out group-hover:opacity-10'>
          {title}
        </h1>
      </motion.div>
      {description && (
        <div className='absolute inset-0 flex items-center justify-center text-center'>
          <motion.div
            className='px-miista-page-padding relative max-w-[30rem] text-pretty'
            style={{ y: descriptionY }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5, duration: 0.5, ease: 'easeOut' }}
          >
            <PortableText prose={false} value={description} locale={locale} />
          </motion.div>
        </div>
      )}
    </motion.header>
  )
}

export default CollectionHeader
